<script lang="ts">
	import { goto } from '$app/navigation'
	import { appState } from '$lib/app-state.svelte'
	import Dropdown from '$lib/public/Dropdown.svelte'
	import DropdownItem from '$lib/public/DropdownItem.svelte'

	async function logout() {
		goto('/login') // Navigate first to avoid errors referencing session.user

		const res = await fetch('/auth/logout', {
			method: 'POST'
		})
		if (res.ok) {
			appState.user = null
		} else {
			console.error(`Logout not successful: ${res.statusText} (${res.status})`)
		}
	}
</script>

<Dropdown label={appState.user!.firstName} class="tw:ms-auto" icon="personSquare">
	<DropdownItem href="/profile" label="Your Profile" />
	<DropdownItem href="/history" label="History" />
	<DropdownItem onclick={logout} label="Sign out" />
</Dropdown>
